/* eslint-disable react/prop-types */
import { EmailAddress } from '@constants';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import feedbackSuccess from '@assets/ra_feedback_success.svg';
import classes from './Feedback.module.css';

const TEXT = {
  title: 'Congrats! You are all set',
  desc: 'Your application has been approved. We’ll have expert to manually insert the widget for you. This will normally be done in 48 hours. Should you have any questions, please contact us at ',
};

export default function Feedback({ FEEDBACK_TEXT = TEXT }) {
  return (
    <div className={classes.feedback}>
      <div className={classes.content}>
        <img src={feedbackSuccess} alt="" className={classes.img} />
        <div className={classes.title}>{FEEDBACK_TEXT.title}</div>
        <div className={classes.desc}>
          {FEEDBACK_TEXT.desc}
          <a
            href={`mailto:${EmailAddress.Seel}`}
            className={classes.contact_support}
          >
            {EmailAddress.Seel}

          </a>
          .
        </div>
        <Link to="/">
          <Button>Back to home</Button>
        </Link>
      </div>
    </div>
  );
}
